import { HttpParams } from '@angular/common/http';
import { SortDirection } from '@angular/material/sort';
import { environment } from './../../../environments/environment';

export class Pageable {
	page: number;
	size: number;
	sort: PageableSort[];
	unpaged: boolean;

	constructor(
		page: number = 0,
		size: number = environment.tablePaginationSizes[0],
		sort: PageableSort[] = [],
		unpaged: boolean = false
	) {
		this.page = page;
		this.size = size;
		this.sort = sort;
		this.unpaged = unpaged;
	}

	createPageableParams(httpParams: HttpParams): HttpParams {
		if (this.unpaged) {
			httpParams = httpParams.set('unpaged', 'true');
		} else {
			httpParams = httpParams.set('page', this.page.toString());
			httpParams = httpParams.set('size', this.size.toString());
		}

		this.sort?.forEach((sortItem) => {
			if (sortItem.field) {
				httpParams = httpParams.append(
					'sort',
					`${sortItem.field},${sortItem.order}`
				);
			}
		});
		return httpParams;
	}
}

export interface IPageableSort {
	field: string;
	order: PageableSortOrder | SortDirection | 'asc' | 'desc';
}

export class PageableSort implements IPageableSort {
	field: string;
	order: PageableSortOrder | SortDirection | 'asc' | 'desc';
}

export enum PageableSortOrder {
	ASC = 'asc',
	DESC = 'desc',
}
